import {NgModule} from '@angular/core';
import {SearchService} from './services/search/search.service';
import {ConfigService} from './services/config/config.service';
import {ModifiedFieldService} from './services/document/modified-field.service';
import {UnsavedDocumentService} from './services/document/unsaved-document.service';
import {ClientRulesService} from './services/rules/client-rules.service';
import {OfflineUtilService} from './services/offline/offline-util.service';
import {BroadcastService} from './services/broadcast/broadcast.service';
import {NotificationService} from './services/notification/notification.service';
import {LocationService} from './services/location.service';
import {ModalService} from './services/modal.service';
import {DocumentListService} from './services/document/document-list.service';
import {ValidationService} from './services/validation/validation.service';
import {WebSocketService} from './services/socket/web-socket.service';
import {ChangedDocumentService} from './services/document/changed-document.service';
import {FinaliseValueFieldService} from './services/document/finalise-value-field.service';
import { OfflineStatusService } from './services/offline-status/offline-status.service';
import {RouterService} from "./services/router/router.service";

@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [
    ConfigService,
    BroadcastService,
    ClientRulesService,
    ModifiedFieldService,
    OfflineUtilService,
    OfflineStatusService,
    SearchService,
    UnsavedDocumentService,
    NotificationService,
    ModalService,
    LocationService,
    DocumentListService,
    ValidationService,
    WebSocketService,
    ChangedDocumentService,
    FinaliseValueFieldService,
    RouterService,
  ],
  exports: []
})
export class FormbirdServicesModule {
  constructor() {
  }
}
